import React, { Component, useState } from 'react';
import './CustomSelect.scss';
import Loading from '../../../../modules/Dashboard/Components/Loading/Loading';
const FILES_API_URL = '/api/v1/files';
const AUDIO_FILES_API_URL = '/api/v1/files/music';
const SERVER_URL = 'https://tca-image-uploads.s3.amazonaws.com';

const FORMATS = '.png, .gif, .jpeg, .jpg, .mp3, .wav, .avi, .mpeg, .mp4, .webm';
const MAX_SIZE = 5;

const getExtension = (src) => /(?:\.([^.]+))?$/.exec(src)[1];

const endsWith = (str = '', suffix) => str.toLowerCase().indexOf(suffix, str.length - suffix.length) !== -1;
export const isAudio = (str) => endsWith(str, '.mp3') || endsWith(str, '.wav');
export const isVideo = (str) =>
  endsWith(str, '.avi') || endsWith(str, '.mpeg') || endsWith(str, '.mp4') || endsWith(str, '.webm');

export const isPicture = (str) =>
  endsWith(str, '.jpeg') || endsWith(str, '.png') || endsWith(str, '.jpg') || endsWith(str, '.gif');

class CustomSelect extends Component {
  constructor() {
    super();

    this.handleShowOption = this.handleShowOption.bind(this);
    this.onRemoveImage = this.onRemoveImage.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.setFileName = this.setFileName.bind(this);
    this.getFoldersDetail = this.getFoldersDetail.bind(this);
    this.handleShowListFile = this.handleShowListFile.bind(this);
    this.onCloseShowFolder = this.onCloseShowFolder.bind(this);
    this.createFolders = this.createFolders.bind(this);
    this.updateNameFolder = this.updateNameFolder.bind(this);
    this.updateFolder = this.updateFolder.bind(this);
    this.toggleShowMode = this.toggleShowMode.bind(this);

    this.state = {
      input: '',
      showPopup: false,
      isFolder: false,
      isFile: false,
      option: {},
      name: '',
      popupNewFolder: false,
      popupList: true,
      rename: false,
      popupListFolder: false,
      currentFolder: {},
    };
  }
  onRemoveImage(id) {
    return this.props.onRemoveImage(id);
  }
  onSelect(item) {
    return this.props.selectFile(item);
  }
  getFiles(query) {
    return this.props.getFiles(query);
  }
  setFileName(value) {
    return this.props.setFileName(value);
  }
  getFoldersDetail(id) {
    return this.props.getFoldersDetail(id);
  }
  onCloseShowFolder() {
    return this.props.onCloseShowFolder();
  }
  deleteFolders(id) {
    return this.props.deleteFolders(id);
  }
  toggleShowMode(boolean) {
    return this.props.toggleShowMode(boolean);
  }
  updateNameFolder() {
    const _data = {
      title: this.state.name,
    };
    return this.props.updateNameFolder(this.state.option.id, _data);
  }
  updateFolder(folder, remove = false) {
    const media = {
      filename: this.state.option.filename,
      url: this.state.option.value,
      pretty: this.state.option.label,
      id: this.state.option.id,
    };
    if (remove) {
      return this.props.updateFolder(this.state.currentFolder.id, media, true, true);
    }
    if (this.props.showFolder) {
      this.props.updateFolder(folder.id, media, false, true);
      return this.props.updateFolder(this.state.currentFolder.id, media, true, true);
    } else {
      return this.props.updateFolder(folder.id, media);
    }
  }
  createFolders() {
    const _data = {
      folderType: 'new',
      titleEn: this.state.name,
      newFolderName: this.state.name,
      media: [],
    };
    return this.props.createFolders(_data);
  }
  handleShowOption = ({ value, label, id, isFolder = false }) => {
    if (isVideo(value)) {
      return (
        <div className="option-item">
          <div className="image">
            <i className="ti-video-clapper" />
            <div>
              <strong>{label}</strong>
            </div>
            {!isFolder && (
              <div
                id={'remove'}
                className="remove"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.onRemoveImage(id);
                  this.toggleShowMode(false);
                }}
              >
                x
              </div>
            )}
          </div>
        </div>
      );
    }

    if (isAudio(value)) {
      return (
        <div className="option-item">
          <div className="image">
            <i className="ti-music-alt" />
            <div>
              <strong>{label}</strong>
            </div>
            {!isFolder && (
              <div
                id={'remove'}
                className="remove"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.onRemoveImage(id);
                  this.toggleShowMode(false);
                }}
              >
                x
              </div>
            )}
          </div>
        </div>
      );
    }

    if (isPicture(value)) {
      return (
        <div className="option-item">
          <div className="image">
            <img className="preview-img-grid" src={value} width={50} />
            <div>
              <strong>{label}</strong>
            </div>
            {!isFolder && (
              <div
                id={'remove'}
                className="remove"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.onRemoveImage(id);
                  this.toggleShowMode(false);
                }}
              >
                x
              </div>
            )}
          </div>
        </div>
      );
    }
  };
  handleShowListFile = (listFile) => {
    if (typeof listFile !== 'string') {
      return (listFile || []).map((item, i) => {
        const option = {
          filename: item.filename ? item.filename : item,
          label: item.pretty ? item.pretty : item,
          value: item.url ? item.url : item,
          isFolder: true,
        };
        if (isVideo(option.value) || isAudio(option.value) || isPicture(option.value)) {
          return (
            <div
              className="option"
              key={i}
              onClick={() => {
                this.setState({
                  showPopup: true,
                  popupList: true,
                  option: option,
                  isFile: true,
                  isFolder: false,
                  name: '',
                  popupNewFolder: false,
                  rename: false,
                  popupListFolder: false,
                });
              }}
            >
              {this.handleShowOption(option)}
            </div>
          );
        }
      });
    } else {
      const option = {
        filename: listFile,
        label: listFile,
        value: listFile,
        isFolder: true,
      };
      if (isVideo(listFile) || isAudio(listFile) || isPicture(listFile)) {
        return (
          <div
            className="option"
            onClick={() => {
              this.setState({
                showPopup: true,
                popupList: true,
                option: option,
                isFile: true,
                isFolder: false,
                name: '',
                popupNewFolder: false,
                rename: false,
                popupListFolder: false,
              });
            }}
          >
            {this.handleShowOption(option)}
          </div>
        );
      }
    }
  };
  render() {
    const { options, fileName, folder, showFolder, listFile, show, loading, ...props } = this.props;

    const {
      input,
      showPopup,
      isFolder,
      isFile,
      option,
      popupList,
      popupNewFolder,
      rename,
      popupListFolder,
      currentFolder,
    } = this.state;
    return (
      <div>
        <div className="select">
          <div className="select-input">
            <input
              className="input"
              type="select"
              onChange={(e) => {
                this.setFileName(e.target.value);
              }}
              onClick={() => this.toggleShowMode(true)}
              value={fileName}
            ></input>
          </div>
          <i className="ti-angle-down"></i>
          <span
            className="clear"
            onClick={() => {
              this.setFileName('');
            }}
          >
            x
          </span>
        </div>
        {loading ? (
          <div className="loading">
            <Loading />
          </div>
        ) : (
          show && (
            <div className="list">
              {!showFolder && (
                <div
                  className="new"
                  onClick={() => {
                    this.setState({
                      popupList: false,
                      popupNewFolder: true,
                      showPopup: true,
                      popupListFolder: false,
                      rename: false,
                      name: '',
                    });
                  }}
                >
                  <div className="new-button">
                    <i className="ti-plus" />
                    New Folder
                  </div>
                </div>
              )}
              {!showFolder ? (
                <div>
                  <div className="showFolder">
                    {(folder || []).map((option, i) => (
                      <div
                        className="folder"
                        key={i}
                        onClick={() => {
                          this.setState({
                            showPopup: true,
                            option: option,
                            isFile: false,
                            isFolder: true,
                            popupNewFolder: false,
                            popupListFolder: false,
                            rename: false,
                            popupList: true,
                          });
                        }}
                      >
                        <i className="ti-folder" />
                        <div className="nameFolder">{option.title}</div>
                      </div>
                    ))}
                  </div>
                  <div className="listFile">
                    {(options || []).map((option, i) => (
                      <div
                        className="option"
                        key={i}
                        onClick={() => {
                          this.setState({
                            showPopup: true,
                            popupList: true,
                            option: option,
                            isFile: true,
                            isFolder: false,
                            popupNewFolder: false,
                            popupListFolder: false,
                            rename: false,
                          });
                        }}
                      >
                        {this.handleShowOption(option)}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="backButton" onClick={() => this.onCloseShowFolder()}>
                    <i className="ti-angle-left" />
                    Back
                  </div>
                  <div className="listFile">{this.handleShowListFile(listFile[0].media)}</div>
                </div>
              )}
              {showPopup && (
                <div
                  className="popup-container"
                  onClick={() => {
                    this.setState({ showPopup: false });
                  }}
                >
                  {popupList && (
                    <div className="popup">
                      {isFolder && (
                        <div
                          className="popup-item"
                          onClick={() => {
                            this.getFoldersDetail(option.id);
                            this.setState({
                              showPopup: false,
                              popupList: false,
                              popupNewFolder: false,
                              popupListFolder: false,
                              rename: false,
                              currentFolder: option,
                            });
                          }}
                        >
                          <i className="ti-target" />
                          Open
                        </div>
                      )}
                      {isFile && (
                        <div
                          className="popup-item"
                          onClick={() => {
                            this.toggleShowMode(false);
                            this.onSelect(option);
                            this.setState({
                              showPopup: false,
                              popupList: false,
                              popupNewFolder: false,
                              popupListFolder: false,
                              rename: false,
                            });
                          }}
                        >
                          <i className="ti-hand-open" />
                          Choose
                        </div>
                      )}

                      <div
                        className={!showFolder ? 'popup-item' : 'popup-item-disable'}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.setState({
                            popupList: false,
                            popupNewFolder: true,
                            showPopup: true,
                            popupListFolder: false,
                            rename: false,
                          });
                        }}
                      >
                        <i className="ti-plus" />
                        New Folder
                      </div>

                      {isFile && (
                        <div
                          className="popup-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.setState({
                              popupNewFolder: false,
                              popupListFolder: true,
                              popupList: false,
                              showPopup: true,
                              rename: false,
                            });
                          }}
                        >
                          <i className="ti-location-arrow" />
                          Move
                        </div>
                      )}
                      {isFolder && (
                        <div
                          className="popup-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.setState({
                              popupList: false,
                              popupNewFolder: true,
                              rename: true,
                              popupListFolder: false,
                              showPopup: true,
                            });
                          }}
                        >
                          <i className="ti-marker-alt" />
                          Rename
                        </div>
                      )}

                      <div
                        className="popup-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          if (isFile) {
                            if (showFolder) {
                              this.updateFolder(option, true);
                              this.setState({ showPopup: false });
                            } else {
                              this.onRemoveImage(option.id);
                              this.setState({ showPopup: false });
                            }
                          }
                          if (isFolder) {
                            this.deleteFolders(option.id);
                            this.setState({ showPopup: false });
                          }

                          this.toggleShowMode(false);
                          this.onCloseShowFolder();
                        }}
                      >
                        <i className="ti-trash" />
                        Remove
                      </div>
                    </div>
                  )}
                  {popupNewFolder && (
                    <div
                      className="new-folder-container"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <div className="new-folder">
                        {rename ? 'Rename' : 'New Folder'}
                        <input
                          onChange={(e) => this.setState({ name: e.target.value })}
                          defaultValue={rename ? option.title : ''}
                        />
                        <div className="text">
                          <p
                            className="text-cancel"
                            onClick={() => this.setState({ popupNewFolder: false, showPopup: false, rename: false })}
                          >
                            Cancel
                          </p>
                          <p
                            className="text-create"
                            onClick={() => {
                              this.setState({ popupNewFolder: false, showPopup: false, rename: false });
                              if (rename) {
                                return this.updateNameFolder();
                              }
                              this.createFolders();
                            }}
                          >
                            {rename ? 'Update' : 'Create'}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  {popupListFolder && (
                    <div
                      className="new-list-folder-container"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <div className="showFolder">
                        {(folder || []).map((option, i) => (
                          <div
                            className="folder"
                            key={i}
                            onClick={() => {
                              this.updateFolder(option);
                              this.setState({ popupListFolder: false, showPopup: false, rename: false });
                            }}
                          >
                            <i className="ti-folder" />
                            <div className="nameFolder">{option.title}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        )}
      </div>
    );
  }
}

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/CustomSelect/CustomSelect.js